import React from 'react'

export function Button({
  children,
  color = 'blue',
  loading = false,
  className = '',
  disabled = false,
  ...props
}: React.PropsWithChildren<{
  loading?: boolean
  onClick?: () => void
  color?: 'blue'
  disabled?: boolean
  className?: string
}>) {
  const child = (
    <>
      {children}
      {loading ? (
        <svg
          className="animate-spin -mr-1 ml-3 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      ) : null}
    </>
  )

  /**
   * https://tailwindcss.com/docs/optimizing-for-production
   */
  const colorClasses = (): string => {
    switch (color) {
      default:
      case 'blue':
        return 'bg-blue-500 hover:bg-blue-700'
    }
  }

  return (
    <button
      type="button"
      className={`${className} ${colorClasses()} disabled:opacity-50 text-white font-bold py-2 px-4 rounded inline-flex items-center disabled:opacity-50`}
      disabled={loading || disabled}
      {...props}
    >
      {child}
    </button>
  )
}
